module.exports = __webpack_public_path__ + "img/img-10.0c842c0b.png";